export enum TransferType {
  Primary = 'primary',
  Sell = 'sell',
  Gift = 'gift',
}
